import React, { useState, useEffect } from "react";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import AddGender from "./AddGender";

const EditGenderDialog = (props) => {
  console.log("dsd");

  return (
    <>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
      >
        <DialogTitle id="form-dialog-title">
          Editar una nueva oración
        </DialogTitle>
        <DialogContent>
          <AddGender
            word={props.word}
            handleClose={props.handleClose}
          ></AddGender>
          {/* <EditExistingWordDialog
            word={this.props.words[this.props.selected]}
            sets={this.props.sets}
            handleClose={this.handleClose}
            collection_name={this.props.collection_name}
          ></EditExistingWordDialog> */}
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleClose} color="primary">
            Subscribe
          </Button>
        </DialogActions> */}
      </Dialog>
    </>
  );
};

export default EditGenderDialog;
